// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.area-btns[data-v-34c1feb0] {\n  gap: 24px;\n}\n.item-text[data-v-34c1feb0] {\n  font-size: 20px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
